/* Pages collection : tiroir de filtres, tri, scroll infini.
   Filtres et tri = navigation native (paramètres d'URL Shopify) ;
   le scroll infini recharge la section via la Section Rendering API. */
(function () {
  var d = document.documentElement;

  /* ===== Tiroir de filtres ===== */
  var btn = document.getElementById('btn-filtres');
  var tiroir = document.getElementById('tiroir-filtres');
  var voile = document.getElementById('tiroir-voile');
  var fermerBtn = document.getElementById('tf-close');

  function ouvrir() {
    if (!tiroir) return;
    tiroir.classList.add('on');
    if (voile) voile.classList.add('on');
    d.classList.add('tiroir-open');
    if (btn) btn.setAttribute('aria-expanded', 'true');
    if (fermerBtn) fermerBtn.focus();
  }
  function fermer() {
    if (!tiroir || !tiroir.classList.contains('on')) return;
    tiroir.classList.remove('on');
    if (voile) voile.classList.remove('on');
    d.classList.remove('tiroir-open');
    if (btn) {
      btn.setAttribute('aria-expanded', 'false');
      btn.focus();
    }
  }
  if (btn) btn.addEventListener('click', ouvrir);
  if (fermerBtn) fermerBtn.addEventListener('click', fermer);
  if (voile) voile.addEventListener('click', fermer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') fermer();
  });

  /* ===== Formulaire de filtres : ne pas envoyer les champs vides ===== */
  var form = document.getElementById('filtres-form');
  if (form) {
    form.addEventListener('submit', function () {
      Array.prototype.forEach.call(form.querySelectorAll('input'), function (el) {
        if (el.type !== 'checkbox' && !el.value) el.disabled = true;
      });
    });
  }

  /* ===== Tri : navigation immédiate au changement ===== */
  var tri = document.getElementById('col-tri');
  if (tri && form) {
    tri.addEventListener('change', function () {
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    });
  }

  /* ===== Scroll infini (Section Rendering API) ===== */
  var sentinelle = document.getElementById('col-sentinelle');
  var grille = document.getElementById('col-grille');
  var compteur = document.getElementById('col-compteur');
  var finCol = document.getElementById('fin-col');
  /* lien « Voir plus » : vrai <a rel="next"> pour Google et sans JS ;
     ici il déclenche le chargement, affiche l'attente, puis suit la pagination */
  var suite = document.getElementById('col-suite');
  var suiteTexte = suite ? suite.textContent : '';
  if (!sentinelle || !grille || !('IntersectionObserver' in window)) return;
  var occupe = false;

  function suiteAttente(actif) {
    if (!suite) return;
    suite.textContent = actif ? (suite.getAttribute('data-chargement') || suiteTexte) : suiteTexte;
    if (actif) suite.setAttribute('aria-busy', 'true');
    else suite.removeAttribute('aria-busy');
  }

  function chargerSuite() {
    var url = sentinelle.getAttribute('data-suivant');
    if (!url || occupe) return;
    occupe = true;
    suiteAttente(true);
    fetch(url)
      .then(function (r) { if (!r.ok) throw new Error('page'); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nouvelleGrille = doc.getElementById('col-grille');
        var nouvelleSentinelle = doc.getElementById('col-sentinelle');
        var nouveauCompteur = doc.getElementById('col-compteur');
        if (nouvelleGrille) {
          Array.prototype.slice.call(nouvelleGrille.children).forEach(function (carte) {
            grille.appendChild(carte);
          });
        }
        if (compteur && nouveauCompteur) compteur.textContent = nouveauCompteur.textContent;
        var suivant = nouvelleSentinelle ? nouvelleSentinelle.getAttribute('data-suivant') : null;
        if (suivant) {
          sentinelle.setAttribute('data-suivant', suivant);
          if (suite) suite.href = suivant.replace(/&section_id=[^&]*/, '');
        } else {
          sentinelle.removeAttribute('data-suivant');
          if (suite) suite.hidden = true;
          /* fin de collection : seulement sans filtre actif (le compteur suffit sinon) */
          if (finCol && sentinelle.getAttribute('data-filtres-actifs') === '0') {
            finCol.hidden = false;
          }
        }
      })
      .catch(function () {})
      .finally(function () { occupe = false; suiteAttente(false); });
  }

  if (suite) {
    suite.addEventListener('click', function (e) {
      e.preventDefault();
      chargerSuite();
    });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) chargerSuite();
    });
  }, { rootMargin: '600px 0px' });
  io.observe(sentinelle);
})();
